<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">

        <projectMenu :project="project"></projectMenu>

        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>

          <div class="text-end mb-3">
            <ProjectFilesHistory :projectId="project.id" />
          </div>

          <div class="card-body">
            <div class="row mt-3">
              <div class="col-sm-12" v-if="projectFileData">
                <h4>Plik projektu</h4>

                <div v-if="isLoading">
                  <div class="position-absolute w-100 h-100 text-center" style="z-index: 9">
                    <div class="spinner-border text-danger me-2 align-self-center loader-lg" style="top:20%"></div>
                  </div>
                </div>

                <div :style="{ opacity: isLoading ? '0.4' : '1' }">
                  <ejs-grid id="GridProjectFile" ref="gridProjectFile" :key="gridProjectKey" gridLines="Both"
                    class="top-margin" height='100%' :keyPressed="onKeyDown" :allowExcelExport='true'
                    :dataSource="projectFileData" :editSettings="editSettings" :allowPaging="true"
                    :pageSettings='pageSettings' :allowSorting='true' :allowFiltering='true'
                    :filterSettings="filterOptions" :allowReordering='true' :allowResizing='true' :allowTextWrap="true"
                    :showColumnChooser='true' :selectionSettings='selectionOptions' :allowSelection='true'
                    :enablePersistence="true" :toolbar='toolbar' :cellSave="onCellSave" :toolbarClick="toolbarClickE"
                    :batchCancel="onCancelAction" :beforeBatchSave="beforeBatchSave"
                    :contextMenuItems="contextMenuItems" :contextMenuClick="onContextMenuClick"
                    :contextMenuOpen="onContextMenuOpen" :rowSelecting="onRowSelecting" :rowDataBound="onRowDataBound"
                    :dataBound="dataBound">
                    <e-columns>
                      <e-column field='id' headerText='ID' width="85" :allowEditing="false"
                        isPrimaryKey="true"></e-column>
                      <e-column field="topic" headerText="Temat" type="string"></e-column>
                      <e-column field="priority" type="number" headerText="Priorytet"></e-column>
                      <e-column field="topic2" type='string' headerText="Temat"></e-column>
                      <e-column field="person_responsible_for" headerText="Osoba odpowiedzialna" editType="dropdownedit"
                        type="string" :edit="personResponsibleParams"></e-column>
                      <e-column field="resolution_steps" type='string'
                        headerText="Kroki podjęte do rozwiązania problemu"></e-column>
                      <e-column field="meeting_date" headerText="Data spotkania" type="date" editType='datepickeredit'
                        format='dd.MM.yyyy' :edit='datePickerParams'></e-column>
                      <e-column field="percentages" headerText="%" type='string' width="70"></e-column>
                      <e-column field="status" headerText="Status" editType="dropdownedit" :edit="statusParams"
                        type="string"></e-column>
                      <e-column field="additional_points" type='string' headerText="Dodatkowe punkty"></e-column>
                      <e-column field="correspondence_url" headerText="Url" type='string'></e-column>
                      <e-column field='created_by_name' headerText='Stworzył' :allowEditing="false"></e-column>
                      <template v-if="hasPermission('canViewProjectInfo')">
                        <e-column field="poufne" headerText="Poufne" width="120" :allowEditing="false"
                          :template="'confidentialTemplate'" :allowFiltering='false'></e-column>
                      </template>

                      <template #confidentialTemplate="{ data }">
                        <select class="form-select form-select-sm" :value="Number(data.poufne)" @change="savePoufne({
                          rowData: data,
                          checked: Number($event.target.value)
                        })">
                          <option :value="1">Tak</option>
                          <option :value="0">Nie</option>
                        </select>
                      </template>
                    </e-columns>
                  </ejs-grid>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="row g-0">
            <GraphProjectFileProgress :projectId="project.id"></GraphProjectFileProgress>
          </div>
        </div>
      </div>
    </div>

    <SendNotatkaModal v-if="showSendNotatkaModal" :project="project" :users="users" :users_list="users_list" :selectedNoteRows="selectedNoteRows"
      :projectFiles="projectFiles" ref="SendNotatkaModalRef" @added-article="this.$refs.GridProjectFile.refresh()"
      @added-success="successMsg" @added-error="errorMsg" @close="showSendNotatkaModal = false" />


  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import projectMenu from "@/Pages/Projects/parts/projectMenu.vue";
import GraphProjectFileProgress from '../../../Components/Widgets/Graphs/GraphProjectFileProgress.vue';
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import SendNotatkaModal from "./SendNotatkaModal.vue";

import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit, ExcelExport,
  Filter,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar
} from '@syncfusion/ej2-vue-grids';

import { ComboBox } from '@syncfusion/ej2-dropdowns';
import ProjectFilesHistory from "../Histories/ProjectFilesHistory.vue";

const { hasRole, hasPermission } = usePermission();

export default {
  components: {
    hasPermission,
    SendNotatkaModal,
    ProjectFilesHistory,
    AppLayout, projectMenu, GraphProjectFileProgress,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },
  props: {
    project: Object,
    users: Array,
	users_list: Array,
    projectFiles: Object,
    now_restore_table: {
      type: Number,
      default: 1
    },
    table_settings: {
      type: Object,
      default: null
    }
  },

  setup(page) {
    const canViewConfidential = hasPermission('canViewProjectInfo');

    const projectFileData = page.projectFiles
      .filter(row => canViewConfidential || Number(row.poufne) !== 1)
      .map(row => ({
        ...row,
        meeting_date: row.meeting_date
          ? new Date(row.meeting_date)
          : null
      }));

    return {
      usersData: page.users,
      projectFileData
    };
  },

  data() {
    return {
      contextMenuItems: [
        {
          text: 'Wyślij notatkę',
          target: '.e-content',
          id: 'send_note'
        }
      ],
      showSendNotatkaModal: false,
      selectedNoteRows: [],
      showSendNoteModal: false,
      isLoading: false,
      hasPermission,
      tableSettingsApplied: false,
      hasTableSettings: false,
      gridProjectKey: 0,
      pageSettings: { pageSize: 15, pageCount: 5, pageSizes: [15, 20, 50, 100, 200, 500, 1000] },
      filterOptions: { type: "Excel" },
      projectFileRules: { required: true },
      comboBoxObj: null,
      editSettings: {
        allowEditing: true,
        allowAdding: true,
        allowDeleting: true,
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch'
      },
      selectionOptions: {
        type: 'Multiple',
        mode: 'Row'
      },
      datePickerParams: {
        params: {
          weekNumber: true, // Włącz numer tygodnia
          format: 'dd.MM.yyyy', // Ustawienie formatu daty
        }
      },


      personResponsibleParams: {
        create: () => {
          return document.createElement('input');
        },

        read: () => {
          return this.comboBoxObj.value;
        },

        destroy: () => {
          if (this.comboBoxObj) {
            this.comboBoxObj.destroy();
            this.comboBoxObj = null;
          }
        },

        write: (args) => {
          this.comboBoxObj = new ComboBox({
            dataSource: [...new Set(this.users)]
              .filter(user => user)
              .map(person_responsible_for => ({
                person_responsible_for
              })),

            fields: {
              text: 'person_responsible_for',
              value: 'person_responsible_for'
            },

            allowCustom: true,
            allowFiltering: true,
            filterType: 'Contains',
            ignoreCase: true,
            autofill: false,
            popupHeight: '250px',
            placeholder: 'Wpisz, aby wyszukać osobę...'
          });

          this.comboBoxObj.appendTo(args.element);
        }
      },


      statusParams: {
        params: {
          dataSource: [
            { 'status': 'In Progress' },
            { 'status': 'Late' },
            { 'status': 'Ready' },
            { 'status': 'To Do' },
            { 'status': 'Zaznaczone' },
          ],
          fields: { text: "status", value: "status" }
        }
      },
    }
  },

  provide:
  {
    grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ContextMenu]
  },

  mounted() {
    this.restoreTableIfNeeded();
  },

  watch: {
    table_settings: {
      immediate: true,
      deep: true,
      handler(value) {
        this.hasTableSettings = !!(value?.settings);
      }
    }
  },
  computed: {
    toolbar() {
      return this.getToolbar();
    }
  },

  methods: {
    onRowDataBound(args) {
      if (Number(args.data.poufne) === 1) {
        args.row.classList.add('confidential-row');
      } else {
        args.row.classList.remove('confidential-row');
      }
    },
    onContextMenuOpen(args) {
      const grid = this.$refs.gridProjectFile?.ej2Instances;

      if (!grid || grid.getSelectedRecords().length === 0) {
        args.cancel = true;
      }
    },

    onRowSelecting() {
      this.showSendNoteModal = false;
    },

    onContextMenuClick(args) {
      if (args.item.id !== 'send_note') {
        return;
      }

      const grid = this.$refs.gridProjectFile?.ej2Instances;

      if (!grid) {
        return;
      }

      this.selectedNoteRows = [...grid.getSelectedRecords()];

      if (this.selectedNoteRows.length > 0) {
        this.showSendNotatkaModal = true;
      }
    },

async savePoufne(args) {
  const row = args.rowData;
  const oldValue = Number(row.poufne);
  const newValue = Number(args.checked);

  // Zabezpieczenie przed nieprawidłową wartością
  if (newValue === oldValue) {
    return;
  }

  try {
    const response = await axios.post(
      route('projects.show.project-file.confidential', {
        project: this.project.id
      }),
      {
        id: row.id,
        poufne: newValue
      }
    );

    if (response.data.success) {
      // Aktualizacja danych rekordu bez przeładowania tabeli
      row.poufne = Number(response.data.poufne);

      // Aktualizacja koloru wyłącznie danego wiersza
      const grid = this.$refs.gridProjectFile?.ej2Instances;
      const rowElement = grid?.getRowByIndex(
        grid.getRowIndexByPrimaryKey(row.id)
      );

      if (rowElement) {
        rowElement.classList.toggle(
          'confidential-row',
          Number(row.poufne) === 1
        );
      }

      this.successMsg('Zmieniono status poufności.');
    }
  } catch (error) {
    console.error(
      'Błąd zapisu poufności:',
      error.response?.data || error
    );

    // Przywrócenie poprzedniej wartości
    row.poufne = oldValue;

    this.$refs.gridProjectFile?.ej2Instances?.refreshRows();

    this.errorMsg('Nie udało się zmienić statusu poufności.');
  }
},


    restoreTableIfNeeded() {
      if (this.now_restore_table !== 0) {
        return;
      }

      let grid = this.$refs.gridProjectFile;

      if (!grid || !grid.$el || !grid.ej2Instances) {
        return;
      }

      let gridName = 'grid' + grid.$el.id;

      grid.ej2Instances.enablePersistence = false;

      window.localStorage.setItem(gridName, "");

      grid.ej2Instances.destroy();

      (function stripIdsFromUrl() {
        try {
          const url = new URL(window.location.href);

          url.searchParams.delete('ids');
          url.searchParams.delete('ids[]');

          history.replaceState(
            history.state,
            '',
            url.toString()
          );
        } catch (e) {
          const href = window.location.href;

          const cleaned = href
            .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
            .replace(/[?&]$/, '');

          history.replaceState(
            history.state,
            '',
            cleaned
          );
        }
      })();
      this.applyTableSettings();
      location.reload();
    },
    applyTableSettings() {
      const grid = this.$refs.gridProjectFile?.ej2Instances;

      if (!grid || !this.table_settings?.settings) {
        return;
      }

      let settings;

      try {
        settings = JSON.parse(this.table_settings.settings);
      } catch (error) {
        console.error('Błąd odczytu ustawień tabeli:', error);
        return;
      }
      if (!Array.isArray(settings)) {
        return;
      }
      settings.forEach(setting => {
        if (!setting.field) {
          return;
        }
        const column = grid.columns.find(
          col => col.field === setting.field
        );
        if (!column) {
          return;
        }
        if (setting.width !== undefined) {
          column.width = setting.width;
        }
        column.visible = setting.visible !== false;
      });

      grid.refreshColumns();

      const savedFields = settings
        .filter(setting => setting.field)
        .sort((a, b) => a.index - b.index)
        .map(setting => setting.field);

      const currentFields = grid.columns
        .filter(column => column.field)
        .map(column => column.field);

      savedFields.forEach((field, targetIndex) => {
        const currentIndex = currentFields.indexOf(field);

        if (currentIndex === -1 || currentIndex === targetIndex) {
          return;
        }

        const targetField = currentFields[targetIndex];

        if (!targetField) {
          return;
        }

        grid.reorderColumns(
          field,
          targetField
        );

        // aktualizujemy tylko lokalną kolejność FIELD
        currentFields.splice(currentIndex, 1);
        currentFields.splice(targetIndex, 0, field);
      });

      grid.refreshColumns();
    },

    route,
    isRouteActive(routeName) {
      return route().current() === routeName;
    },

    onCellSave(args) {
      if (args.previousValue !== args.value) {
        this.$makeDirty();
      }
    },

    onCancelAction() {
      this.$makeClean();
    },
    getToolbar() {
      const tools = [];
      tools.push("Add",
        { text: 'Usuń', prefixIcon: 'e-delete', id: 'delete_btn' },
        "Update",
        "Cancel",
        { text: "Search", prefixIcon: 'e-search', id: "search", align: 'center' });

      tools.push({ text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' });
      if (this.hasTableSettings) {
        tools.push({ text: "Usuń ustawienia", prefixIcon: 'e-delete', id: "delete-set", align: 'right' });
      }

      tools.push({ text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right' },
        { text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right' },
        "ColumnChooser"
      );
      return tools;
    },

    toolbarClickE: async function (args) {
      if (args.item.id === 'delete_btn') {
        Toast.fire({
          toast: false,
          icon: 'warning',
          title: 'Usuwanie Wiersza',
          html: 'Na pewno chcesz usunąć wybrane wiersze?',
          showDenyButton: true,
          timer: false,
          position: 'center',
          showConfirmButton: true,
          confirmButtonText: 'Tak, usuń!',
          denyButtonText: 'Nie',
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteRow();
          }
        });
        return false;
      }

      if (args.item.id === 'restore') {
        let grid = this.$refs.gridProjectFile;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
        location.reload();
      }
      if (args.item.id === 'save') {
        const grid = this.$refs.gridProjectFile?.ej2Instances;

        if (!grid) {
          console.warn('Grid nie został znaleziony');
          this.errorMsg("Konfiguracja tabeli nie została zapisana!");
          return;
        }

        const tableId = 'gridProjectFile';

        const settings = grid.columns.map((column, index) => ({
          field: column.field || null,
          index: index,
          width: column.width,
          visible: column.visible !== false
        }));

        try {
          const response = await axios.post('/table-settings', {
            tableId: tableId,
            columns: JSON.stringify(settings)
          });

          this.hasTableSettings = true;
          this.successMsg(
            "Konfiguracja tabeli została pomyślnie zapisana!"
          );

        } catch (error) {
          console.error(
            'Błąd zapisu ustawień:',
            error.response?.data || error
          );

          this.errorMsg(
            "Konfiguracja tabeli nie została zapisana!"
          );
        }
      }
      if (args.item.id === 'delete-set') {
        const tableId = 'gridProjectFile';
        try {
          const response = await axios.delete('/table-settings-delete', {
            data: {
              tableId: tableId
            }
          }
          );
          this.hasTableSettings = false;
          this.successMsg(
            "Konfiguracja tabeli została pomyślnie usunięta!"
          );
        } catch (error) {
          this.errorMsg(
            "Konfiguracja tabeli nie została usunięta!"
          );
        }
      }

      if (args.item.id === 'excelexport') {
        this.$refs.gridProjectFile.excelExport({
          fileName: `${this.project.number}-plik projektu.xlsx`
        });
      }
    },

    onKeyDown: function (args) {
      let keyCode = args.which || args.keyCode;
      let isCtrlKey = (args.ctrlKey || args.metaKey) ? true : ((keyCode === 17));

      // code 83 to 'S'
      if (isCtrlKey && keyCode === 83) {
        args.preventDefault();

        // zapisz
        let toolbar = document.getElementsByClassName('e-toolbar-left')[0];
        let buttons = toolbar.querySelectorAll('.e-toolbar-item');
        let updateButton = buttons[2].querySelector('button');
        if (updateButton) {
          updateButton.click();
        }
      }
    },

    deleteRow() {
      let self = this;
      this.isLoading = true;
      const scrollPosition = window.scrollY;
      let gridInstance = document.getElementById('GridProjectFile').ej2_instances[0];
      const selectedIndexes = gridInstance.getSelectedRowCellIndexes();
      let deletedRows = selectedIndexes.map(o => gridInstance.currentViewData[o.rowIndex]);
      deletedRows = deletedRows.map(obj => obj.id); // zmiana na array tylko z id

      selectedIndexes.forEach(o => {
        gridInstance.deleteRecord('id', gridInstance.currentViewData[o.rowIndex]);
      });

      axios.delete(route('projects.show.project-file.delete', {
        project: self.project,
        projectFiles: JSON.stringify(deletedRows)
      })).then(response => {
        if (response.status === 200) {
          Toast.fire({
            position: 'top-end',
            toast: true,
            icon: response.data.icon,
            title: response.data.title,
            html: response.data.message,
          });
        } else {
          console.log(response);
          Toast.fire({
            position: 'center',
            toast: false,
            icon: response.data.icon,
            title: response.data.title,
            html: response.data.message,
            timer: false,
            showCloseButton: true
          });
        }
        self.reloadGrid();
        self.updateProjectFilesRows();
        self.isLoading = false;
        this.$makeClean();
        this.$nextTick(() => {
          window.scrollTo(0, scrollPosition);
        });
      }).catch(error => {
        console.log(error);
      });
    },

    dataBound() {
      if (!this.tableSettingsApplied) {
        this.tableSettingsApplied = true;
        this.applyTableSettings();
      }

      let gridInstance = document.getElementById('GridProjectFile').ej2_instances[0];
      gridInstance.hideScroll();
    },


    beforeBatchSave() {
      this.isLoading = true;
      const changes = this.$refs.gridProjectFile.getBatchChanges();

      const added = changes.addedRecords || [];
      const changed = changes.changedRecords || [];

      const modified = [...added, ...changed];

      if (modified.length === 0) {
        this.isLoading = false;
        return;
      }

      this.updateProjectFilesRows(modified);
    },

    updateProjectFilesRows(rows) {
      const self = this;
      axios.post(route('projects.show.project-file.update', self.project.id), {
        'rows': rows
      }).then(response => {
        self.reloadGrid();
        this.projectFileData = response.data;
        self.isLoading = false;
        this.$makeClean();
      }).catch(error => {
        console.log(error);
      })
    },

    reloadGrid() {
      this.gridProjectKey += 1;
    },
    successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  }
}
</script>

<style>
@import "@syncfusion/ej2-vue-grids/styles/material.css";
@import "@syncfusion/ej2-base/styles/material.css";
@import "@syncfusion/ej2-buttons/styles/material.css";
@import "@syncfusion/ej2-calendars/styles/material.css";
@import "@syncfusion/ej2-dropdowns/styles/material.css";
@import "@syncfusion/ej2-inputs/styles/material.css";
@import "@syncfusion/ej2-navigations/styles/material.css";
@import "@syncfusion/ej2-popups/styles/material.css";
@import "@syncfusion/ej2-splitbuttons/styles/material.css";

[id$="_excelexport"] {
    float: right;
}

.send-note-modal {
    position: fixed;
    inset: 0;
    z-index: 10000;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    background: #fff;
}

.send-note-modal-content {
    min-height: 100vh;
    padding: 30px;
}

#GridProjectFile .e-gridcontent tr.confidential-row > td {
    background-color: #fbe9eb !important;
}

#GridProjectFile .e-gridcontent tr.confidential-row:hover > td {
    background-color: #f7d6da !important;
}

#GridProjectFile .e-gridcontent td.e-selectionbackground {
    background-color: #9fc5ff !important;
}

#GridProjectFile .e-gridcontent tr.confidential-row.e-selectionbackground > td,
#GridProjectFile .e-gridcontent tr.confidential-row > td.e-selectionbackground {
    background-color: #9fc5ff !important;
}

#GridProjectFile .e-gridcontent tr.e-active > td,
#GridProjectFile .e-gridcontent tr.e-selectionbackground > td {
    background-color: #9fc5ff !important;
}

#GridProjectFile .e-gridcontent tr.e-active:hover > td,
#GridProjectFile .e-gridcontent tr.e-selectionbackground:hover > td,
#GridProjectFile .e-gridcontent tr.confidential-row:hover > td.e-selectionbackground {
    background-color: #76adff !important;
}

#GridProjectFile .e-gridcontent tr.e-active > td,
#GridProjectFile .e-gridcontent tr.e-selectionbackground > td {
    border-top-color: #6da5f5 !important;
    border-bottom-color: #6da5f5 !important;
}
</style>